import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'kt-perfiloperador',
  templateUrl: './perfiloperador.component.html',
  styleUrls: ['./perfiloperador.component.scss']
})
export class PerfiloperadorComponent implements OnInit {
  public imagen;
  public datos;
  constructor(private dialogRef: MatDialogRef<PerfiloperadorComponent>,
		@Inject(MAT_DIALOG_DATA) public data) { }

    ngOnInit() {
      this.imagen = this.data.fotoOperador.substring(19);
      this.datos =this.data;
      this.dialogRef.updateSize("25%")
    }
  
    public minimizarPopup() {
      this.dialogRef.addPanelClass('displayNone');
    }
  
    public maximizarPopup() {
      this.dialogRef.removePanelClass('displayNone');
    }
  
    public cerrarPopup() {
      this.dialogRef.close();
    }
  }
